import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { AlertModalService, ToastState } from '../../services/AlertModalService';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-container.component.html'
})
export class ToastContainerComponent implements OnInit {
  toastState$: Observable<ToastState>;

  constructor(private alertModalService: AlertModalService) {
    this.toastState$ = this.alertModalService.toastState$;
  }

  ngOnInit(): void {}

  getToastClass(toastType: string): string {
    switch (toastType) {
      case 'success':
        return 'bg-green-500 text-white';
      case 'error':
        return 'bg-red-500 text-white';
      case 'warning':
        return 'bg-yellow-500 text-black';
      case 'info':
        return 'bg-blue-500 text-white';
      default:
        return 'bg-gray-500 text-white';
    }
  }

  closeToast(id: number): void {
    this.alertModalService.hideToast(id);
  }
}
